export default "/images/vendor/flag-icon-css/flags/4x3/gb.svg?516897fd3988e35032b772b026a19f75";